import { centsToDollars, parsePrice } from "helpers/price";
import { HorizontalLine } from "pages/Dashboard/components/styled";
import { useMemo } from "react";
import styled from "styled-components";

const StyledTag = styled.div<{ top: boolean }>`
  background-color: ${({ top }) => (top ? "var(--primary-color)" : "#EDF1FD")};
  color: ${({ top }) => (top ? "white" : "var(--primary-color)")};
  min-width: 32px;
  min-height: 32px;
`;

export function TopScoringPayers({ dataFromAPI }: { dataFromAPI: any }) {
  const topPayers = useMemo(() => {
    if (!dataFromAPI?.data?.length) return [];
    const filteredPayers = dataFromAPI.data.filter(
      (payer: any) =>
        payer.payerName !== "Clear health" &&
        payer.payerName !== "Self-Pay Rate"
    );
    const top1 = filteredPayers[0];
    const top2 = filteredPayers[1];
    const top3 = filteredPayers[2];
    return [top1, top2, top3];
  }, [dataFromAPI]);
  return (
    <div className="w-full flex flex-column gap-3">
      {topPayers?.length ? (
        topPayers.map((payer, index) => (
          <div className="flex flex-column">
            <div key={index} className="flex gap-3">
              <StyledTag
                className={`w-2rem h-2rem border-circle  justify-content-center align-items-center flex `}
                top={index === 0}
              >
                {index + 1}
              </StyledTag>
              <div className="flex flex-column gap-1 flex-1">
                <div className="flex justify-content-between gap-3 md:flex-row flex-column">
                  <p className="text-sm font-bold text-primary">
                    {payer.payerName}
                  </p>
                  <div className="w-9rem">
                    <p className="text-sm text-gray-600">
                      Payer scroe:{" "}
                      <span className="font-semibold text-gray-800">
                        {payer.payerScore}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex md:flex-row flex-column justify-content-between gap-3">
                  <div className="flex flex-column">
                    <p className="text-md mt-2">
                      {parsePrice(
                        centsToDollars(Number(payer.avgTotalAllowable))
                      )}
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Avg total allowable (ATA)
                    </p>
                  </div>
                  <div className="flex flex-column">
                    <p className="text-md mt-2">
                      {Number(payer.avgPtPortionPercent).toFixed(2)}%
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      Avg pt portion %
                    </p>
                  </div>
                  <div className="flex flex-column w-9rem">
                    <p className="text-md mt-2">{payer.avgPtConversionRate}%</p>
                    <p className="text-xs text-gray-600 mt-1">
                      Avg pt conversion rate
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <HorizontalLine className="mb-0 mt-3" />
          </div>
        ))
      ) : (
        <div className="w-full p-4 flex justify-content-center items-center">
          <p className="text-gray-new-600 text-sm font-normal">
            No Data to show
          </p>
        </div>
      )}
    </div>
  );
}
